import { apiFetch } from '../lib/apiFetch'
import { createLogger } from "../lib/logger";
import { logVisioClientEvent } from './visioClientLog'

const slog = createLogger("visio");

/**
 * Fire-and-forget visio event logger for session statistics.
 * Never throws — silently drops on failure.
 */
export function logVisioEvent(
  roomId: string | undefined,
  eventType: string,
  eventData?: Record<string, unknown>,
  opts?: { isGuest?: boolean; guestId?: string },
) {
  if (!roomId) return
  slog.action(eventType, { roomId, ...eventData });
  logVisioClientEvent(roomId, eventType, eventData, {
    guestId: opts?.isGuest ? opts.guestId : undefined,
  })
  if (opts?.isGuest && opts.guestId) {
    fetch(`/api/visio/guest-events/${roomId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType, guest_id: opts.guestId, event_data: eventData }),
    }).catch(() => {})
  } else {
    apiFetch(`/api/visio/rooms/${roomId}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType, event_data: eventData }),
    }).catch(() => {})
  }
}
